(function () {
  var ROOT_SELECTOR = "[data-feedback-page]";

  var ratingAliases = {
    "1": "terrible",
    terrible: "terrible",
    "2": "bad",
    bad: "bad",
    "3": "okay",
    ok: "okay",
    okay: "okay",
    "4": "good",
    good: "good",
    "5": "great",
    great: "great"
  };

  var ratingPrompts = {
    terrible: "I'm sorry it was not a good experience. What went wrong, and what would you want us to fix first?",
    bad: "Thanks for being honest. What could we improve before your next case?",
    okay: "Thanks. What would make the experience easier or more useful for your office?",
    good: "Glad to hear it. What worked well, and what should we keep doing?",
    great: "Wonderful. What made the experience great for your office?"
  };

  function getParam(params, names) {
    for (var i = 0; i < names.length; i += 1) {
      var value = params.get(names[i]);
      if (value) return value;
    }

    return "";
  }

  function normalizeRating(value) {
    var normalized = String(value || "").trim().toLowerCase();
    return ratingAliases[normalized] || "great";
  }

  function getField(root, selector) {
    return root.querySelector(selector);
  }

  function setStatus(status, message, type) {
    if (!status) return;
    status.textContent = message || "";
    status.classList.toggle("is-error", type === "error");
    status.classList.toggle("is-success", type === "success");
  }

  function getSessionKey(payload) {
    return [
      "elegant-feedback-click",
      payload.email || "anonymous",
      payload.rating || "unknown",
      payload.campaign || "campaign"
    ].join(":");
  }

  function initFeedbackPage(root) {
    if (!root || root.dataset.feedbackReady === "true") return;
    root.dataset.feedbackReady = "true";

    var params = new URLSearchParams(window.location.search);
    var endpointUrl = root.dataset.endpointUrl || "";
    var autoSaveClick = root.dataset.autoSaveClick === "true";
    var form = getField(root, "[data-feedback-form]");
    var ratingInput = getField(root, "[data-feedback-rating]");
    var emailInput = getField(root, "[data-feedback-email]");
    var sourceInput = getField(root, "[data-feedback-source]");
    var campaignInput = getField(root, "[data-feedback-campaign]");
    var companyInput = getField(root, "[data-feedback-company]");
    var firstNameInput = getField(root, "[data-feedback-first-name]");
    var lastNameInput = getField(root, "[data-feedback-last-name]");
    var contactIdInput = getField(root, "[data-feedback-contact-id]");
    var messageInput = getField(root, "[data-feedback-message]");
    var prompt = getField(root, "[data-feedback-prompt]");
    var status = getField(root, "[data-feedback-status]");
    var submit = root.querySelector(".feedback-page__submit");
    var buttons = root.querySelectorAll("[data-feedback-rating-option]");
    var selectedRating = normalizeRating(getParam(params, ["rating", "score", "sentiment"]));
    var initialEmail = getParam(params, ["email", "contact_email"]);

    if (!form || !ratingInput) return;

    emailInput.value = initialEmail;
    sourceInput.value = getParam(params, ["source", "utm_source"]) || "brevo";
    campaignInput.value = getParam(params, ["campaign", "utm_campaign"]);
    companyInput.value = getParam(params, ["company", "practice", "office", "contact_company"]);
    firstNameInput.value = getParam(params, ["first_name", "firstname", "firstName"]);
    lastNameInput.value = getParam(params, ["last_name", "lastname", "lastName"]);
    contactIdInput.value = getParam(params, ["contact_id", "contactId", "id"]);

    function selectRating(value) {
      selectedRating = normalizeRating(value);
      ratingInput.value = selectedRating;

      buttons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.rating === selectedRating));
      });

      if (prompt && prompt.dataset.feedbackPromptStatic !== "true" && ratingPrompts[selectedRating]) {
        prompt.textContent = ratingPrompts[selectedRating];
      }
    }

    function buildPayload(eventType, includeMessage) {
      var sourceParts = [sourceInput.value || "brevo"];

      if (campaignInput.value) {
        sourceParts.push(campaignInput.value);
      }

      sourceParts.push(eventType);

      return {
        rating: ratingInput.value,
        email: emailInput.value.trim(),
        feedback: includeMessage && messageInput ? messageInput.value.trim() : "",
        source: sourceParts.join(":"),
        pageUrl: window.location.href,
        userAgent: window.navigator.userAgent || "",
        campaign: campaignInput.value,
        company: companyInput.value,
        firstName: firstNameInput.value,
        lastName: lastNameInput.value,
        contactId: contactIdInput.value,
        website: form.elements.website ? form.elements.website.value : ""
      };
    }

    async function saveFeedback(eventType, options) {
      options = options || {};

      if (!endpointUrl) {
        throw new Error("Feedback endpoint is not configured.");
      }

      var payload = buildPayload(eventType, Boolean(options.includeMessage));

      if (payload.website) {
        return { ok: true, ignored: true };
      }

      var response = await fetch(endpointUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
      var result = await response.json().catch(function () {
        return {};
      });

      if (!response.ok || !result.ok) {
        throw new Error(result.error || "Could not save feedback.");
      }

      return result;
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        selectRating(button.dataset.rating);

        if (!emailInput.value.trim() || !autoSaveClick) return;

        saveFeedback("rating_update", { includeMessage: false }).then(function () {
          setStatus(status, "Rating updated.", "success");
        }).catch(function () {
          setStatus(status, "", "");
        });
      });
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      setStatus(status, "Saving...", "");
      if (submit) submit.disabled = true;

      saveFeedback("comment_submit", { includeMessage: true }).then(function () {
        setStatus(status, "Saved. Thank you for helping us improve.", "success");
      }).catch(function (error) {
        setStatus(status, error.message || "Could not save feedback.", "error");
      }).finally(function () {
        if (submit) submit.disabled = false;
      });
    });

    selectRating(selectedRating);

    if (autoSaveClick && emailInput.value.trim()) {
      var clickPayload = buildPayload("rating_click", false);
      var sessionKey = getSessionKey(clickPayload);

      try {
        if (window.sessionStorage && window.sessionStorage.getItem(sessionKey)) {
          return;
        }
      } catch (error) {
        // Browsers can block storage in private contexts; feedback still works.
      }

      saveFeedback("rating_click", { includeMessage: false }).then(function () {
        try {
          if (window.sessionStorage) {
            window.sessionStorage.setItem(sessionKey, "1");
          }
        } catch (error) {
          // Ignore storage failures.
        }
      }).catch(function () {
        setStatus(status, "", "");
      });
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initFeedbackPage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(initFeedbackPage);
  });
})();
